/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step2_ArtifactInputs */

const en_dr_step2_artifact = /** @type {(inputs: Dr_Step2_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–3 personas: who, how they cope today, where it hurts`)
};

const id_dr_step2_artifact = /** @type {(inputs: Dr_Step2_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–3 persona: siapa, cara mereka bertahan hari ini, di mana sakitnya`)
};

/**
* | output |
* | --- |
* | "1–3 personas: who, how they cope today, where it hurts" |
*
* @param {Dr_Step2_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step2_artifact = /** @type {((inputs?: Dr_Step2_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step2_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step2_artifact(inputs)
	return en_dr_step2_artifact(inputs)
});